// extracted by mini-css-extract-plugin
export default {"text":"text__3664fac0","link":"link__3664fac0"};